!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("lodash.throttle")) : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.AblyUi = t(require("lodash.throttle")) : (e.AblyUi = e.AblyUi || {}, e.AblyUi.Core = e.AblyUi.Core || {}, e.AblyUi.Core.Slider = t(e[void 0]));
}(this, e => (() => {
  "use strict";

  var t = {
      7326: t => {
        t.exports = e;
      }
    },
    n = {};
  function r(e) {
    var o = n[e];
    if (void 0 !== o) return o.exports;
    var i = n[e] = {
      exports: {}
    };
    return t[e](i, i.exports, r), i.exports;
  }
  r.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return r.d(t, {
      a: t
    }), t;
  }, r.d = (e, t) => {
    for (var n in t) r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: t[n]
    });
  }, r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
  var o = {};
  return (() => {
    r.d(o, {
      default: () => d
    });
    var e = r(7326),
      t = r.n(e),
      n = function (e) {
        return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document).querySelector("[data-id=".concat(e, "]"));
      },
      i = function (e) {
        return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document).querySelectorAll("[data-id=".concat(e, "]"));
      },
      c = function (e) {
        var t = n("slider-strip", e),
          r = Array.from(i("slider-slide", e)),
          o = n("slider-previous", e),
          c = n("slider-next", e),
          d = Array.from(i("slider-marker", e)),
          l = n("slider-controls", e);
        l.classList.replace("hidden", "flex");
        var a = r.length,
          s = e.getBoundingClientRect().width,
          u = r[0].getBoundingClientRect(),
          f = u.width,
          v = u.left,
          h = r[1].getBoundingClientRect().left - v - f,
          p = (s - f) / 2,
          y = 0,
          m = 0,
          x = function (e) {
            return t.style.transform = "translateX(".concat(function (e) {
              return e * -f + p + e * -h;
            }(e), "px)");
          },
          b = function (e) {
            d.forEach(function (e) {
              return e.classList.remove("text-active-orange");
            }), d[e].classList.remove("text-cool-black"), d[e].classList.add("text-active-orange");
          },
          g = function () {
            x(y = y - 1 <= 0 ? 0 : y - 1), b(y);
          },
          L = function () {
            x(y = y + 1 >= a ? y : y + 1), b(y);
          };
        return x(0), b(0), o.addEventListener("click", g), t.addEventListener("touchstart", function (e) {
          var t;
          m = null === (t = e.touches[0]) || void 0 === t ? void 0 : t.clientX;
        }), t.addEventListener("touchend", function (e) {
          var t,
            n = (null === (t = e.changedTouches[0]) || void 0 === t ? void 0 : t.clientX) - m;
          Math.abs(n) < 20 || (n > 0 ? g : L)();
        }), c.addEventListener("click", L), function () {
          t.style.transform = null, l.classList.replace("flex", "hidden");
        };
      };
    const d = function (e) {
      var n = e.container,
        r = e.mqEnableThreshold;
      if (n) {
        var o = r || function () {
            return !window.matchMedia("(min-width: 48rem)").matches;
          },
          i = function () {};
        o() && (i = c(n)), window.addEventListener("resize", t()(function () {
          o() ? i = c(n) : i();
        }, 100));
      }
    };
  })(), o.default;
})());